// true: login tramite GMAL (bridge mcd) | false: avvio senza utente GMAL con dati fissi
const gmalLogin = false;
const defaultUserName = 'Michele'; // diventa "Michelestein"

let AppStarted = false;
let firstRun = false;

// Gestion del nome del "DOTTORE"
// ==================================================
let userName = '';
setUserName(userName);
function setUserName(userName) {
    userName = userName.split(' ')[0];
    const newName = userName.slice(0, 7) + 'stein';
    userName = newName;
    document.querySelectorAll('.js--btn-share').forEach(elem => {
        elem.dataset.name = newName;
    });

    document.querySelectorAll('.js--name').forEach(elem => {
        elem.textContent = newName;
    });
}
// ==================================================



function addTag(tag) {
    debugAlert = false;
    (debugAlert) && alert('Aggiunta tag // //');
    user = mcd.bridge.message('user');
    user.send({ "addTags": [tag] });
    user.on('data', function (data) {
        // addLog("add tags data: " + JSON.stringify(data));
        (debugAlert) && alert('Aggiunta tag // Inizio');
    });
    user.on('error', function (error) {
        // addLog("add tags error: " + JSON.stringify(error));
        (debugAlert) && alert('Aggiunta tag // Errore');
        showPage();
    });
    user.on('done', function () {
        (debugAlert) && alert('Aggiunta tag // Finito');
    });
}

document.addEventListener('DOMContentLoaded', () => {

    // Attivazione offerte
    //---------------------------------------------------
    //event listener for bridge ready
    document.addEventListener('mcdBridgeReady', function(e) {
        const user = mcd.bridge.message('user');

        var system = mcd.bridge.message('system');
        // alert('bridge - Fullscreen + Hide Close Button');
        // system.send({"fullscreen" : "true", "hideCloseButton" : "true"});
        // alert('bridge - Hide Close Button');
        system.send({"hideCloseButton" : "true"});

        const userData = gmalLogin && new Promise((resolve,reject)=>{
            user.send({ promptlogin: true });
            user.on("data", (data) => {
                setUserName(data.firstname);
                !AppStarted && startApp(); 
            })
            user.on('error', (err) => function(){
            // window.location.replace('https://www.mcdonalds.it');
            });
        });

        function goToOffers(){
            window.location = "gmalite://gmalite-deals";
        };

        function activateOffer(loyaltyId, rewardId) {
            return new Promise((resolve, reject) => {
                let offerActivation = mcd.bridge.message('offerActivation');

                offerActivation.on("data", function (data) {
                    console.log('Offer activation success:', data);
                    resolve(data);
                });

                offerActivation.on("error", function (error) {
                    console.log('Offer activation error:', error);
                    var errorType = error['code'];
                    switch (errorType) {
                        case 100: //ADDING_POINT_FAILED
                            console.log('ADDING_POINT_FAILED');
                            break;
                        case 101: //ACTIVATE_REWARD_FAILED
                            console.log('ACTIVATE_REWARD_FAILED');
                            break;
                        case 400: //INVALID_REQUEST_PARAM
                            console.log('INVALID_REQUEST_PARAM');
                            break;
                        case 403: //USER_NOT_LOGGED
                            console.log('USER_NOT_LOGGED');
                            break;
                        case 408: //REQUEST_TIME_OUT:
                            console.log('REQUEST_TIME_OUT');
                            break;
                        default:
                            break;
                    }
                    reject(error);
                });
                
                offerActivation.send({
                    'loyaltyId': loyaltyId,
                    'autoActivate': false, //autoActivate true works only if you have only one reward in loyalty card.
                    'rewardId': rewardId
                });
            });
        }

        (function() {
            document.querySelectorAll('.js--active-offer').forEach(button => {
                button.addEventListener('click', async () => {
                    const rewardId = button.dataset.rewardId;
                    const loyaltyId = button.dataset.loyaltyId;
                    const fusionId = button.dataset.fusionId;
                    
                    trackGAEvent('btn_active_offer', {
                        event_category: 'btn_active_offer',
                        fusion_id: fusionId,
                    });

                    button.setAttribute('disabled', 'disabled');
                    // alert('activate offer : ' + loyaltyId + ' - ' + rewardId);
                    
                    try {
                        // const result = await activateOffer(loyaltyId, rewardId);
                        button.removeAttribute('disabled');
                        goToOffers();
                    } catch (error) {
                        button.removeAttribute('disabled');
                        goToOffers();
                    }
                });
            });
        })();
    });

    const debug = false;

    const assetBasePath = 'https://fb-r2.c1-p8.com/';

    function startApp() {
        AppStarted = true;
        showScreen('intro');
        // showScreen('welcome');
        // showScreen('home');
        // showScreen('experiments');
        // showScreen('productGrid');
        // showScreen('productSlider');
        // showScreen('prefusion');
        // showScreen('fusion');
        // showScreen('finalProduct');
    }

    // interval = setInterval(()=>{
    //     if (AppStarted) {
    //         clearInterval(interval);
    //     } else {
    //         startApp();
    //     }
    // }, 1000)

    const resizeListener = () => {
        const aspectRatio = window.innerWidth / window.innerHeight;
        const aspectRatioStandard = 390/844;
        if (aspectRatio > aspectRatioStandard) {
            document.body.classList.add('height-set');
            let width = window.innerHeight * aspectRatioStandard;
            document.querySelector('#productSlider .product-wrapper').style.width = `${width}px`;
        }
    }


    document.querySelectorAll('.js--custom-event').forEach(button => {
        button.addEventListener('click', (e) => {
            trackGAEvent('button_click', {
                event_category: e.dataset.category,
                event_label: e.dataset.label,
            });
        });
    });

    window.addEventListener('resize', resizeListener);
    resizeListener();

    // Dati Pagina
    // ==================================================
    const data = getLocalData();
    let fusionID = '';
    // ==================================================

    // Dati Prodotti - Caricati dinamicamente da JSON
    // ==================================================
    let baseProducts = [];
    let additionalProducts = [];
    let fusionResults = {};
    let fusionProducts = [];
    
    // Funzioni per caricare i dati JSON
    async function loadBaseProducts() {
        try {
            const response = await fetch('./data/base_products.json');
            baseProducts = await response.json();
        } catch (error) {
            console.error('Errore nel caricamento dei prodotti base:', error);
        }
    }
    
    async function loadAdditionalProducts() {
        try {
            const response = await fetch('./data/additional_products.json');
            additionalProducts = await response.json();
        } catch (error) {
            console.error('Errore nel caricamento dei prodotti aggiuntivi:', error);
        }
    }
    
    async function loadFusionResults() {
        try {
            const response = await fetch('./data/fusion_results.json');
            fusionResults = await response.json();
        } catch (error) {
            console.error('Errore nel caricamento dei risultati di fusione:', error);
        }
    }
    
    // Carica tutti i dati JSON
    async function loadAllData() {
        await Promise.all([
            loadBaseProducts(),
            loadAdditionalProducts(),
            loadFusionResults()
        ]);
        debug && console.log('fusionResults', fusionResults);
    }
    
    // Gestione Google Analytics Events
    // ==================================================
    function trackGAEvent(eventName, parameters = {}) {
        // Verifica se gtag è disponibile
        if (typeof gtag !== 'undefined') {
            gtag('event', eventName, parameters);
            debug && console.log(`GA Event tracked: ${eventName}`, parameters);
        } else {
            debug && console.warn('Google Analytics (gtag) non disponibile');
            debug && console.log(`GA Event (simulato): ${eventName}`, parameters);
        }
    }
    
    function trackGAPageView(pageTitle) {
        if (typeof gtag !== 'undefined') {
            gtag('config', 'GA_MEASUREMENT_ID', {
                page_title: pageTitle,
                page_location: window.location.href,
            });
            debug && console.log(`GA Page View tracked: ${pageTitle}`);
        } else {
            debug && console.log(`GA Page View (simulato): ${pageTitle}`);
        }
    }
    // ==================================================
    

    // Elementi
    // ==================================================
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        slidesPerView: 1,
    
        // If we need pagination
        pagination: {
        el: '.swiper-pagination',
        },
    
        // Navigation arrows
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
    });
    const productTemplate = document.getElementById('product-item-template').content.cloneNode(true);
    // ==================================================


    // Carica i dati JSON e poi inizializza l'app
    loadAllData().then(() => {
        createProductSwiper();
        createExperimentList();
    });

    function createProductSwiper() {
        baseProducts.forEach(product => {
            addSlides(product);
        });

    }

    function addSlides(product) {
        const newSlide = productTemplate.cloneNode(true);
        newSlide.querySelector('.product-item').dataset.product = product.id;
        newSlide.querySelector('button').dataset.product = product.id;
        newSlide.querySelector('.product-image').src = assetBasePath + product.image;
        newSlide.querySelector('.product-image').alt = product.name;
        newSlide.querySelector('button').addEventListener('click', () => {
            openFusion(product.id);
        });
        swiper.appendSlide(newSlide);
    }

    document.querySelectorAll('.js--tutorial-toggle').forEach(button => {
        button.addEventListener('click', () => {
            document.getElementById('home').classList.toggle('tutorial-visible');
        });
    });

    document.querySelectorAll('.js--goto').forEach(button => {
        button.addEventListener('click', () => {
            
            const ID = button.dataset.goto;
            const productId = button.dataset.product;
            showScreen(ID, productId);
            if (ID == 'productSlider') {
                const productArrayId = Number(productId) - 1;
                if (productArrayId >= 0 && productArrayId < baseProducts.length) {
                    product = baseProducts[productArrayId];
                } else {
                    product = additionalProducts[productArrayId - baseProducts.length];
                }
                trackGAEvent('product_selected', {
                    event_category: 'product_interaction',
                    event_label: product.name,
                    product_id: product.id,
                });
            }
            if (ID == 'finalProduct') {
                const fusionID = button.dataset.fusionId;
                trackGAEvent('btn_create', {
                    event_category: 'btn_create',
                    fusion_id: fusionID,
                });
            }
        });
    });
    
    document.querySelectorAll('.js--force-play').forEach(button => {
        let debugForcePlay = false;
        button.addEventListener('click', () => {
            debugForcePlay && alert('force play');
            const video = document.getElementById('intro').querySelector('video');
            if (video) {
                debugForcePlay && alert('video trovato');
                video.currentTime = 0;
                video.play();
            }
        });
    });
    
    document.querySelectorAll(".js--btn-share").forEach((button) => {
        button.addEventListener("click", async (e) => {
            const fusionID = button.dataset.fusionId;
            const name = button.dataset.name;
            const sharePosition = button.dataset.position;
            trackGAEvent('share', {
                event_category: 'share ' + sharePosition,
                fusion_id: fusionID,
            });
            await navigator.share({
                title: "",
                text: "",
                url: "https://www.mcdonalds.it/frankenstein-burger-2025--share--" + fusionID.replace("_", ""),
            });
        });
    });
    
    document.querySelectorAll('.js--start-fusion').forEach(button => {
        button.addEventListener('click', startFusion);
    });
    
    document.getElementById('introVideo').addEventListener('ended', () => {
        showScreen('welcome');
    });
    
    // Avvia audio quando il video intro parte (significa che c'è stata interazione utente)
    document.getElementById('introVideo').addEventListener('play', () => {
        if (window.audioManager) {
            window.audioManager.playBackgroundAudio();
        }
    }, { once: true }); // Solo la prima volta

    document.getElementById('fusionVideo').addEventListener('play', () => {
        if (window.audioManager) {
            window.audioManager.playEffect('fusion');
        }
    }, { once: true }); // Solo la prima volta
    
    document.getElementById('welcomeVideo').addEventListener('ended', () => {
        showScreen('home');
    });

    document.getElementById('stormVideo').addEventListener('ended', () => {
        showScreen('fusion');
    });

    document.getElementById('fusionVideo').addEventListener('ended', () => {
        showScreen('fusionResult');
    });
    
    // document.getElementById('productGridVideo').addEventListener('ended', () => {
    //     document.getElementById('productGrid').classList.add('grid-show');
    // });
    
    // document.getElementById('fusionVideo').addEventListener('ended', () => {
    //     showScreen('finalProduct');
    // });


    
    document.getElementById('js--force-start').addEventListener('click', () => {
        debug && console.log('force start');
        const screen = document.getElementById('intro');
        screen.classList.remove('video-timeout');
        const video = screen.querySelector('video');
        if (video) {
            video.currentTime = 0;
            video.play();
            screen.classList.remove('video-timeout');
        }
    });
    
    function createExperimentList() {
        const experimentsList = [];
        let i = 0;

        Object.keys(fusionResults).forEach(experimentId => {
            const fusionProducts = experimentId.split('_').map(Number);
            
            const fusionID = (Number(fusionProducts[0]) < Number(fusionProducts[1])) ?
                (fusionProducts[0] < 10 ? '0' : '') + fusionProducts[0] + '_' + (fusionProducts[1] < 10 ? '0' : '') + fusionProducts[1] :
                (fusionProducts[1] < 10 ? '0' : '') + fusionProducts[1] + '_' + (fusionProducts[0] < 10 ? '0' : '') + fusionProducts[0];
            if (!experimentsList.includes(fusionID)) {
                i++;
                debug && console.log('Experiment : ', i + ' | ' + fusionID);
                experimentsList.push(fusionID);
                const fusionImageUrl = assetBasePath + 'images/results/'+ fusionID + '.png';
                const experimentItem = document.getElementById('experiment-item-template').content.cloneNode(true);
                experimentItem.querySelector('img').src = fusionImageUrl;
                experimentItem.querySelector('.experiment-item').dataset.experiment = fusionID;
                experimentItem.querySelector('.experiment-item').addEventListener('click', (e) => {
                    debug && console.log(e.target);
                    e.target.classList.contains('active') && openExperimentDetails(fusionID);
                });
                if (data.experiments.includes(fusionID)) {
                    experimentItem.querySelector('.experiment-item').classList.add('active');
                }
                document.getElementById('experiments').querySelector('.experiments-grid').appendChild(experimentItem);
            }
        });
    }
    
    function showScreen(id, productId) {
        document.querySelectorAll('.visible').forEach(s => {
            const video = s.querySelector('video');
            if (video) { video.pause(); }
            s.classList.remove('visible');
            s.classList.remove('show');
        });
        debug && console.log('showScreen', id);
        document.getElementById(id).classList.add('visible');
        
        
        // Track GA event quando viene mostrata una schermata
        trackGAEvent('screen_view', {
            event_category: 'navigation',
            event_label: id,
            screen_name: id,
            product_id: productId || null
        });
        
        // Track anche come page view per schermate principali
        if (['intro', 'welcome', 'home', 'productGrid', 'fusion', 'finalProduct'].includes(id)) {
            trackGAPageView(id, `Frankenstein Burger - ${id}`);
        }
        if (id == 'home') {
            // riporta la leva e le luci in posizione iniziale
            document.getElementById('prefusion').classList.remove('start-fusion');
            // resetta il video di BG dello step prefusion
            const video = document.getElementById('prefusion').querySelector('video');
            if (video) {
                video.currentTime = 0;
            }
            // svuota l'array dei prodotti fusi
            document.querySelectorAll('.steps > .first.active').forEach(elem => {
                elem.classList.remove('active');
            });
            fusionProducts = [];
            document.querySelectorAll('.product-item.active').forEach(elem => {
                elem.classList.remove('active');
            });
        }
        if (id === 'home') {
            // if (getLocalTutorial() != 'done') {
            if (!firstRun) {
                trackGAEvent('tutorial_first_time', {
                    event_category: 'tutorial_first_time',
                });
                setTimeout(() => {
                    document.getElementById('home').classList.add('tutorial-visible');
                }, 2000);
                setLocalTutorial('done');
                firstRun = true;
            }
            document.getElementById('productGrid').classList.add('grid-show');
        } else if (id === 'productSlider') {
            swiper.slideTo(productId - 1);
        }
        {
            const video = document.getElementById(id).querySelector('video');
            if (video) {
                video.currentTime = 0;
                video.play();
            }
        }
        setTimeout(() => {
            document.getElementById(id).classList.add('show');
            if (window.audioManager && (
                id == 'experimentDetails' ||
                id == 'experimentList' ||
                id == 'productSlider' ||
                id == 'productGrid' ||
                id == 'finalProduct'
            )) {
                window.audioManager.playEffect('zap');
            }
            if (id == 'intro') {
                // Controllo timeout per il video intro
                const introVideo = document.getElementById('introVideo');
                const introPanel = document.getElementById('intro');
                
                if (introVideo && introPanel) {
                    // Timer di 2 secondi per controllare se il video è partito
                    const videoTimeout = setTimeout(() => {
                        // Controlla se il video non è ancora partito (currentTime è 0 e non è in pausa)
                        if (introVideo.currentTime === 0 && introVideo.paused) {
                            debug && console.log('Video intro non partito dopo 2 secondi, aggiungendo classe timeout');
                            introPanel.classList.add('video-timeout');
                        }
                    }, 2000);
                    
                    // Rimuovi il timeout se il video inizia a riprodursi
                    introVideo.addEventListener('play', () => {
                        clearTimeout(videoTimeout);
                        introPanel.classList.remove('video-timeout');
                    });
                    
                    // Rimuovi il timeout se il video inizia a caricarsi
                    introVideo.addEventListener('loadstart', () => {
                        clearTimeout(videoTimeout);
                        introPanel.classList.remove('video-timeout');
                    });
                }
            }
            if (id == 'welcome') {
                if (window.audioManager) {
                    window.audioManager.playEffect('video_scienziato');
                }
            }
            if (id == 'home') {
                if (window.audioManager) {
                    window.audioManager.playEffect('video_home');
                }
            }
            if (id == 'storm') {
                if (window.audioManager) {
                    window.audioManager.playEffect('video_storm');
                }
            }
            if (id == 'fusion') {
                if (window.audioManager) {
                    window.audioManager.playEffect('fusion');
                }
            }
        }, 200);
    };
    
    function openFusion(productId) {
        fusionProducts.push(productId);
        if (fusionProducts.length > 1) {
            debug && console.log('fusionProducts');
            let productId1 = '';
            let productId2 = '';
            debug && console.log('fusionProducts', fusionProducts);
            debug && console.log(Number(fusionProducts[0]) > Number(fusionProducts[1]));
            debug && console.log(Number(fusionProducts[0]) > Number(fusionProducts[1]));
            if (Number(fusionProducts[0]) > Number(fusionProducts[1])) {
                fusionID = fusionProducts[1] + '_' + fusionProducts[0];
                productId1 = fusionProducts[1];
                productId2 = fusionProducts[0];
            } else {
                fusionID = fusionProducts[0] + '_' + fusionProducts[1];
                productId1 = fusionProducts[0];
                productId2 = fusionProducts[1];
            }
            document.getElementById('js--product-1').src = assetBasePath + 'images/products/'+productId1+'.png';
            document.getElementById('js--product-2').src = assetBasePath + 'images/products/'+productId2+'.png';// Reset degli stati della griglia
            const total = swiper.slides.length;
            swiper.removeSlide([total - 3, total - 2, total - 1]);
            document.querySelectorAll('.js--panel').forEach(elem => {
                elem.classList.remove('open');
            });
            productFusion();
        } else {
            showScreen('productGrid');
            document.querySelectorAll('.product-item.hidden').forEach(elem => {
                elem.classList.remove('hidden');
            });
            additionalProducts.forEach(product => {
                addSlides(product);
            });
            setTimeout(() => {
                if (window.audioManager) {
                    console.log('playEffect panel');
                    window.audioManager.playEffect('panel');
                }
                setTimeout(() => {
                    document.querySelectorAll('.js--panel').forEach(elem => {
                        elem.classList.add('open');
                    });
                }, 100);
            }, 100);
            document.querySelectorAll('.steps > .first').forEach(elem => {
                elem.classList.add('active');
            });
            document.querySelectorAll('.product-item[data-product="'+productId+'"]').forEach(elem => {
                elem.classList.add('active');
            });
        }
    };
    
    function startFusion() {
        document.getElementById('prefusion').classList.add('start-fusion');
        if (window.audioManager) {
            window.audioManager.playEffect('leva');
        }
        setTimeout(() => {
            showScreen('storm');
        }, 2600);
    };

    function getFusionOffer(fusionID) {
        const fusionResult = fusionResults[fusionID];
        return fusionResult;
    }
    
    function productFusion() {
        showScreen('prefusion');
        // showScreen('finalProduct');
        const fusionResult = getFusionOffer(fusionID);
        console.log(fusionResult);

        debug && console.log('fusionID', fusionID);
        if (!data.experiments.includes(fusionID)) {
            setLocalData({
                experiments: [...data.experiments, fusionID]
            });
        }
        
        // Track GA event quando viene completata una fusione
        trackGAEvent('fusion_completed', {
            event_category: 'product_interaction',
            fusion_id: fusionID,
        });
        
        // prepara il video di fusione
        document.getElementById('fusionVideo').src = assetBasePath + fusionResult.video_fusion;
        document.getElementById('fusionResultVideo').src = assetBasePath + fusionResult.video_result;
        // mostra il prodotto finale
        document.querySelector('#fusionResult .js--btn-share').dataset.fusionId = fusionID;
        document.querySelector('#fusionResult .js--goto').dataset.fusionId = fusionID;
        document.querySelector('#finalProduct a').dataset.rewardId = fusionResult.rewardId;
        document.querySelector('#finalProduct a').dataset.loyaltyId = fusionResult.loyaltyId;
        document.querySelector('#finalProduct a').dataset.fusionId = fusionID;
        
        document.querySelector('#finalProduct').dataset.color = fusionResult.color;
        document.querySelector('#finalProduct #product-image').src = assetBasePath + fusionResult.image_social;
        document.querySelector('#finalProduct #experiment-number').textContent = '#' + fusionID.replace("_", "");
        // document.querySelector('#finalProduct p').textContent = fusionID.replace("_", "") + ' - ' + 'ID Stamp: ' + fusionResult.rewardId + ' - ' + 'ID Card: ' + fusionResult.loyaltyId;
        
        // aggiorna la lista degli esperimenti
        document.querySelector('#experiments .experiment-item[data-experiment="'+fusionID+'"]').classList.add('active');
    };

    function openExperimentDetails(fusionID) {
        document.querySelector('#experimentDetails .experiment-details img').src = assetBasePath + fusionResults[fusionID].image_social;
        document.querySelector('#experimentDetails').dataset.color = fusionResults[fusionID].color;
        document.querySelector('#experimentDetails .js--btn-share').dataset.fusionId = fusionID;
        showScreen('experimentDetails', fusionID);
        trackGAEvent('experiment_details', {
            event_category: 'experiment_details',
            fusion_id: fusionID,
        });
    }
    
    // Gestion dei dati dell'account locale
    //---------------------------------------------------
    function getLocalTutorial() {
        return localStorage.getItem('mcd-fb-tutorial');;
    }
    function setLocalTutorial(data) {
        localStorage.setItem('mcd-fb-tutorial', 'done');
    }

    function getLocalData() {
        const data = localStorage.getItem('localData');
        if (data == undefined) {
            return {
                experiments: []
            };
        }
        return JSON.parse(data);
    }

    function setLocalData(data) {
        localStorage.setItem('localData', JSON.stringify(data));
    }

    // Avvio senza login GMAL: nome fisso e partenza immediata
    //---------------------------------------------------
    if (!gmalLogin) {
        setUserName(defaultUserName);
        !AppStarted && startApp();
    }

});